module.exports = __webpack_public_path__ + "static/media/fold.b12a0704.svg";